(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam-fun-collectieknoppen"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-collection-navigation')) {
    customElements.define('sf-collection-navigation', class extends HTMLElement {
      connectedCallback() {
        // Wait for parser-created instances to receive their child elements.
        if (this.setupFrame) cancelAnimationFrame(this.setupFrame);
        this.setupFrame = requestAnimationFrame(() => {
          this.setupFrame = null;
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        if (this.cleanup) this.cleanup();
        const abort = new AbortController();
        const signal = abort.signal;
        let pointerActive = false;
        let movingPanels = false;
        const groups = Array.from(this.querySelectorAll('.sfcn__group'));
        const panels = new Map(groups.map(group => [group, group.querySelector('.sfcn__panel')]));
        const list = this.querySelector('.sfcn__list');
        const panelSlot = this.querySelector('.sfcn__mobile-panels');
        if (!list || !panelSlot) return;
        const desktop = window.matchMedia('(min-width: 990px)');
        const horizontal = () => !desktop.matches && this.dataset.mobileLayout === 'scroll';
        const contains = (group, node) => node && (group.contains(node) || panels.get(group).contains(node));
        const owner = node => groups.find(group => contains(group, node));
        const reveal = control => {
          if (!horizontal() || !control) return;
          const bounds = list.getBoundingClientRect();
          const box = control.getBoundingClientRect();
          if (box.left < bounds.left + 4) list.scrollLeft += box.left - bounds.left - 4;
          else if (box.right > bounds.right - 4) list.scrollLeft += box.right - bounds.right + 4;
        };
        const close = (group, restoreFocus = false) => {
          group.open = false;
          group.querySelector('summary').setAttribute('aria-expanded', 'false');
          const panel = panels.get(group);
          if (panel.parentElement === panelSlot) panel.hidden = true;
          panelSlot.hidden = !horizontal() || !groups.some(item => item.open);
          if (restoreFocus) {
            group.querySelector('summary').focus({preventScroll: true});
            reveal(group.querySelector('summary'));
          }
        };
        const place = () => {
          const useSlot = horizontal();
          const focused = document.activeElement;
          let restoreFocus = false;
          movingPanels = true;
          panelSlot.hidden = !useSlot || !groups.some(item => item.open);
          // Move the existing panel outside the scroll rail on mobile. The
          // links are never cloned, so IDs and editor block references stay unique.
          for (const group of groups) {
            const panel = panels.get(group);
            const destination = useSlot ? panelSlot : group;
            if (panel.parentElement !== destination) {
              if (panel.contains(focused)) restoreFocus = true;
              destination.appendChild(panel);
            }
            panel.hidden = useSlot && !group.open;
          }
          const bounds = list.getBoundingClientRect();
          for (const group of groups) {
            if (!group.open) continue;
            const panel = panels.get(group);
            if (!desktop.matches) {
              panel.style.removeProperty('--sfcn-panel-left');
              continue;
            }
            const item = group.parentElement.getBoundingClientRect();
            const width = panel.getBoundingClientRect().width;
            const minLeft = Math.max(16, bounds.left);
            const maxRight = Math.min(document.documentElement.clientWidth - 16, bounds.right);
            const left = Math.max(minLeft, Math.min(item.left, maxRight - width));
            panel.style.setProperty('--sfcn-panel-left', `${left - item.left}px`);
          }
          if (restoreFocus && focused && this.contains(focused)) focused.focus({preventScroll: true});
          movingPanels = false;
        };
        for (const group of groups) {
          group.querySelector('summary').setAttribute('aria-expanded', String(group.open));
          group.addEventListener('toggle', () => {
            group.querySelector('summary').setAttribute('aria-expanded', String(group.open));
            if (group.open) {
              for (const other of groups) if (other !== group) close(other);
            }
            place();
          }, {signal});
        }
        this.addEventListener('keydown', event => {
          pointerActive = false;
          const focusedGroup = owner(event.target);
          if (horizontal() && event.key === 'Tab' && focusedGroup && focusedGroup.open) {
            const summary = focusedGroup.querySelector('summary');
            const links = Array.from(panels.get(focusedGroup).querySelectorAll('a[href]'));
            let destination = null;
            if (!event.shiftKey && event.target === summary) destination = links[0];
            if (event.shiftKey && event.target === links[0]) destination = summary;
            if (!event.shiftKey && event.target === links[links.length - 1]) {
              const controls = Array.from(list.children).map(item => item.querySelector('.sfcn__button')).filter(item => item && item.matches('a[href], summary'));
              destination = controls[controls.indexOf(summary) + 1];
            }
            if (destination) { event.preventDefault(); destination.focus(); }
          }
          if (event.key !== 'Escape') return;
          const group = (focusedGroup && focusedGroup.open ? focusedGroup : null) || groups.find(item => item.open);
          if (group) {
            event.preventDefault();
            close(group, true);
          }
        }, {signal});
        // Close after a click, so collapsing a mobile group cannot move the
        // next target between pointer-down and pointer-up.
        document.addEventListener('pointerdown', () => { pointerActive = true; }, {signal});
        document.addEventListener('pointerup', () => { pointerActive = false; }, {signal});
        document.addEventListener('pointercancel', () => { pointerActive = false; }, {signal});
        document.addEventListener('click', event => {
          for (const group of groups) if (group.open && !contains(group, event.target)) close(group);
        }, {signal});
        this.addEventListener('focusout', event => {
          const group = owner(event.target);
          if (!movingPanels && !pointerActive && group && group.open && event.relatedTarget && !contains(group, event.relatedTarget)) close(group);
        }, {signal});
        this.addEventListener('focusin', event => {
          if (list.contains(event.target)) reveal(event.target.closest('.sfcn__button'));
        }, {signal});
        this.addEventListener('shopify:block:select', event => {
          const blockId = event.detail && event.detail.blockId;
          const item = Array.from(this.querySelectorAll('[data-sfcn-block]')).find(node => node.dataset.sfcnBlock === blockId);
          const group = item && (owner(item) || item.querySelector('.sfcn__group'));
          if (group) { group.open = true; place(); reveal(group.querySelector('summary')); }
        }, {signal});
        window.addEventListener('resize', place, {signal});
        const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(place) : null;
        if (observer) {
          observer.observe(this);
          for (const group of groups) observer.observe(group);
        }
        this.cleanup = () => {
          abort.abort();
          if (observer) observer.disconnect();
          for (const group of groups) {
            const panel = panels.get(group);
            if (panel.parentElement !== group) group.appendChild(panel);
            panel.hidden = false;
          }
          panelSlot.hidden = true;
        };
        this.setAttribute('data-enhanced', '');
        place();
        reveal(list.querySelector('.sfcn__button[aria-current="page"], .sfcn__group--current > summary'));
      }
      disconnectedCallback() {
        if (this.setupFrame) cancelAnimationFrame(this.setupFrame);
        this.setupFrame = null;
        if (this.cleanup) this.cleanup();
        this.cleanup = null;
        this.removeAttribute('data-enhanced');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam-fun-scrolling-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sf-product-marquee')) {
    customElements.define('sf-product-marquee', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.sf-scroll__viewport');
        if (!this.viewport) return;
        this.track = this.querySelector('.sf-scroll__track');
        this.group = this.querySelector('.sf-scroll__group');
        this.originals = Array.from(this.group.children);
        this.button = this.querySelector('.sf-scroll__toggle');
        this.controls = this.querySelector('.sf-scroll__controls');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.focused = false;
        this.pointerActive = false;
        this.hovered = false;
        this.inView = true;
        this.blockSelected = false;
        this.button.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.button.textContent = this.userPaused ? 'Hervatten' : 'Pauzeren';
          this.button.setAttribute('aria-pressed', String(this.userPaused));
          this.updateMode();
        }, options);
        this.viewport.addEventListener('mouseenter', () => { this.hovered = true; this.syncPlayback(); }, options);
        this.viewport.addEventListener('mouseleave', () => { this.hovered = false; this.syncPlayback(); }, options);
        // Freeze the row before pointer focus. Do not reset or hide a clicked clone.
        this.viewport.addEventListener('pointerdown', () => {
          clearTimeout(this.pointerReleaseTimer);
          this.pointerActive = true;
          this.syncPlayback();
        }, options);
        const releasePointer = () => {
          if (!this.pointerActive) return;
          clearTimeout(this.pointerReleaseTimer);
          // Keep the target still until the native click has completed.
          this.pointerReleaseTimer = setTimeout(() => {
            this.pointerActive = false;
            this.syncPlayback();
          }, 150);
        };
        window.addEventListener('pointerup', releasePointer, options);
        window.addEventListener('pointercancel', releasePointer, options);
        window.addEventListener('blur', releasePointer, options);
        this.viewport.addEventListener('focusin', (event) => {
          // Only keyboard focus switches to the accessible manual list.
          if (this.pointerActive || !event.target.matches(':focus-visible')) return;
          this.focused = true;
          this.updateMode();
          const card = event.target.closest('.sf-scroll__card');
          if (card) this.viewport.scrollLeft = card.offsetLeft - this.originals[0].offsetLeft;
        }, options);
        this.viewport.addEventListener('focusout', (event) => {
          if (!this.focused || this.viewport.contains(event.relatedTarget)) return;
          this.focused = false;
          this.updateMode();
        }, options);
        // On touch devices the pause control also unlocks native swipe scrolling.
        this.mobile.addEventListener('change', () => this.scheduleBuild(), options);
        this.reduced.addEventListener('change', () => this.updateMode(), options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        this.addEventListener('shopify:block:select', () => { this.blockSelected = true; this.updateMode(); }, options);
        this.addEventListener('shopify:block:deselect', () => { this.blockSelected = false; this.updateMode(); }, options);
        this.resize = new ResizeObserver(() => this.scheduleBuild());
        this.resize.observe(this.viewport);
        this.intersection = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        });
        this.intersection.observe(this);
        this.build();
      }
      disconnectedCallback() {
        this.abort?.abort();
        clearTimeout(this.pointerReleaseTimer);
        this.resize?.disconnect();
        this.intersection?.disconnect();
        this.animation?.cancel();
        cancelAnimationFrame(this.pendingBuild);
      }
      scheduleBuild() {
        cancelAnimationFrame(this.pendingBuild);
        this.pendingBuild = requestAnimationFrame(() => this.build());
      }
      clone(node) {
        const copy = node.cloneNode(true);
        copy.dataset.sfClone = '';
        copy.setAttribute('aria-hidden', 'true');
        for (const element of [copy, ...copy.querySelectorAll('*')]) {
          element.removeAttribute('id');
          element.removeAttribute('data-shopify-editor-block');
          if (element.matches('a, button, input, [tabindex]')) element.setAttribute('tabindex', '-1');
        }
        return copy;
      }
      build() {
        if (!this.isConnected || !this.originals.length) return;
        this.animation?.cancel();
        this.querySelectorAll('[data-sf-clone]').forEach(node => node.remove());
        this.classList.remove('is-manual');
        const viewportWidth = this.viewport.clientWidth;
        if (!viewportWidth) return;
        // Repeat only as much as needed to cover wide screens with small collections.
        let attempts = 0;
        while (this.group.getBoundingClientRect().width < viewportWidth && attempts < 30) {
          this.originals.forEach(card => this.group.append(this.clone(card)));
          attempts++;
        }
        const distance = this.group.getBoundingClientRect().width;
        if (!distance) return;
        this.track.append(this.clone(this.group));
        const seconds = Number(this.mobile.matches ? this.dataset.speedMobile : this.dataset.speed);
        const frames = [ { transform: 'translateX(0)' }, { transform: `translateX(-${distance}px)` } ];
        if (this.dataset.reverse === 'true') frames.reverse();
        this.animation = this.track.animate(frames, { duration: Math.max(1, seconds) * 1000, iterations: Infinity, easing: 'linear' });
        this.updateMode();
      }
      updateMode() {
        const manual = this.userPaused || this.focused || this.reduced.matches || this.blockSelected;
        this.classList.toggle('is-manual', manual);
        this.classList.toggle('is-running', !manual);
        this.controls.hidden = this.reduced.matches;
        if (manual) {
          this.animation?.pause();
          if (this.animation) this.animation.currentTime = 0;
          // Inline important overrides the animation in reverse mode too.
          this.track.style.setProperty('transform', 'none', 'important');
        } else {
          this.track.style.removeProperty('transform');
          this.viewport.scrollLeft = 0;
          this.syncPlayback();
        }
      }
      syncPlayback() {
        if (!this.animation) return;
        const pause = this.pointerActive || this.classList.contains('is-manual') || document.hidden || !this.inView || (this.dataset.pauseHover === 'true' && this.hovered);
        if (pause) this.animation.pause(); else this.animation.play();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
